import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminProjectTemplateState } from './admin-project-template.reducer';

export const AdminProjectTemplateKey = 'adminProjectTemplate';

export const getAdminProjectTemplateState =
  createFeatureSelector<AdminProjectTemplateState>(AdminProjectTemplateKey);

export const getAdminProjectTemplateList = createSelector(
  getAdminProjectTemplateState,
  (state: AdminProjectTemplateState) => state.templates,
);

export const getAdminProjectCurrentTemplate = createSelector(
  getAdminProjectTemplateState,
  (state: AdminProjectTemplateState) => state.currentTemplate,
);

export const getAdminProjectTemplateError = createSelector(
  getAdminProjectTemplateState,
  (state: AdminProjectTemplateState) => state.apiError,
);

export const getAdminProjectTemplateRequestInProgress = createSelector(
  getAdminProjectTemplateState,
  (state: AdminProjectTemplateState) => state.requestInProgress,
);
